import dayjs from 'dayjs';

export const Months = [
    { value: '01', label: ('477') },
    { value: '02', label: ('478') },
    { value: '03', label: ('479') },
    { value: '04', label: ('480') },
    { value: '05', label: ('481') },
    { value: '06', label: ('482') },
    { value: '07', label: ('483') },
    { value: '08', label: ('484') },
    { value: '09', label: ('485') },
    { value: '10', label: ('486') },
    { value: '11', label: ('487') },
    { value: '12', label: ('488') },
];

export const getDateWithShortMonthName = (dateAndTime: string, t: (key: string) => string) => {
    const date = dayjs(dateAndTime);
    if (!date.isValid() || [0, 1900].includes(date.year())) return '';

    const monthLabelId = Months.find(m => m.value === date.format('MM'))?.label;
    if (!monthLabelId) return '';

    const monthShort = t(monthLabelId).substring(0, 3);

    if (date.format('MM') === '00') return `${date.year()}`;
    if (date.format('DD') === '00') return `${monthShort} ${date.year()}`;

    return `${date.format('DD')} ${monthShort} ${date.year()}`;
};
